import type {
  SolarPanelsFunnelSettingsFields,
  SolarPanelsFunnelStep,
} from '@innogy/feh/models';
import { initializeSolarPanelsFunnelStepAction } from '@feh/solar-panels-store';

import { mapSolarPanelsFunnelSettingsFields } from '../utils/map-solar-panels-funnel-settings';

export function initializeSolarPanelsFunnelComponent(
  step: SolarPanelsFunnelStep,
  funnelSettings: SolarPanelsFunnelSettingsFields | null | undefined
) {
  return initializeSolarPanelsFunnelStepAction({
    step,
    funnelSettings: mapSolarPanelsFunnelSettingsFields(funnelSettings),
  });
}
